import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";

interface Props {
  primary: number;
  comparison: number;
}

export const TrendPercentage = ({ primary, comparison }: Props) => {
  const calculatePercentage = (totalCurrent: number, totalCompare: number) => {
    if (totalCompare === 0) return 0; // Avoid division by zero

    return ((totalCurrent - totalCompare) / totalCompare) * 100;
  };

  const [percentage, setPercentage] = useState<number>(0);

  useEffect(() => {
    setPercentage(calculatePercentage(primary, comparison));
  }, [primary, comparison]);

  return (
    <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
      <Typography
        variant="text2"
        color={
          percentage === 0
            ? "var(--status-pending-text)"
            : percentage < 0
            ? "var(--green)"
            : percentage > 0
            ? "var(--red)"
            : undefined
        }
      >
        {isNaN(percentage)
          ? undefined
          : `${percentage > 0 ? "-" : ""}${percentage}%`}
      </Typography>

      {percentage < 0 ? (
        <img src="/img/trend-down-20240109.svg" alt="trend-up" />
      ) : percentage > 0 ? (
        <img src="/img/trend-up-20240109.svg" alt="trend-up" />
      ) : undefined}
    </Box>
  );
};
